import { render, staticRenderFns } from "./OperaTemplateFieldTypeWindow.vue?vue&type=template&id=65969b43&"
import script from "./OperaTemplateFieldTypeWindow.vue?vue&type=script&lang=js&"
export * from "./OperaTemplateFieldTypeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports